import careerTitlesService from 'common/career-titles-service'

import types from './types'

const fetchCareerTitles = () => {
  return (dispatch) => {
    dispatch({ type: types.FETCH_CAREER_TITLES_START })
    return careerTitlesService
      .getCareerTitles()
      .then((careerTitles) => {
        dispatch({
          type: types.FETCH_CAREER_TITLES_SUCCESS,
          payload: careerTitles,
        })
      })
      .catch(() => dispatch({ type: types.FETCH_CAREER_TITLES_FAILURE }))
  }
}

export default {
  fetchCareerTitles,
}
